export default __webpack_public_path__ + "static/media/29.bc1dd580.png";